<!-- Modo Movil responsivo -->
<nav class="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
    <div class="container">
        <a class="navbar-brand" [routerLink]="['menu']">
            <img src="assets/images/logo/logo_nopal_2.png" style="width: auto; height: 50px;" alt="La Nopalera Restaurante">
            <span class="navbar-toggler" style="text-align: center"> </span>
        </a>
        <div class="navbar-toggler">
            <span class="text btn btn-success"><i class="fab fa-whatsapp mr-1" ></i> <a href="https://wa.me/{{ empresa.whatsapp }}"  target="_blank"> <span class="text-white"> {{ empresa.phone }}</span></a>
            </span>
        </div>
        <button class="navbar-toggler" type="button" (click)="showMenu = !showMenu;">
            <span class="oi oi-menu"></span>
        </button>

        <div class="collapse navbar-collapse" id="ftco-nav" [ngClass]="{ 'show' : showMenu}">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item" routerLinkActive='cta'><a [routerLink]="['menu']" class="nav-link" (click)="onLinkClick()">Ver Menú</a></li>
                <li *ngIf="!detailUser" class="nav-item" routerLinkActive='cta'><a [routerLink]="['login']" class="nav-link" (click)="onLinkClick()">Iniciar Sesión</a></li>

                <li *ngIf="getAuthorization()">
                    <div class="dropdown-divider"></div>
                </li>
                <li *ngIf="getAuthorization()" class="nav-item" routerLinkActive='cta'><a [routerLink]="['categorias']" class="nav-link" (click)="onLinkClick()">Categorias</a></li>
                <li *ngIf="getAuthorization()" class="nav-item" routerLinkActive='cta'><a [routerLink]="['platillos']" class="nav-link" (click)="onLinkClick()">Platillos</a></li>
                <!-- <li class="nav-item" routerLinkActive='cta'><a [routerLink]="['promociones']" class="nav-link" (click)="onLinkClick()">Promociones</a></li> -->
                <li *ngIf="detailUser" class="nav-item" routerLinkActive='cta'>
                    <a class="nav-link" style="cursor: pointer;" (click)="logout()"> <i class="fas fa-door-closed"></i> Cerrar Sesión</a>
                </li>
            </ul>
        </div>
    </div>
</nav>
<!-- END nav -->
